var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMongoDb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 249,
    viewBox: "0 0 112 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2247 248.567L54.6167 246.309C54.6167 246.309 55.4234 212.624 43.3353 210.206C35.2765 200.858 44.6246 -186.289 73.6356 208.917C73.6356 208.917 63.6436 213.913 61.8702 222.456C59.9354 230.837 61.2247 248.567 61.2247 248.567Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2247 248.567L54.6167 246.309C54.6167 246.309 55.4234 212.624 43.3353 210.206C35.2765 200.858 44.6246 -186.289 73.6356 208.917C73.6356 208.917 63.6436 213.913 61.8702 222.456C59.9354 230.837 61.2247 248.567 61.2247 248.567Z",
    fill: "#A6A385"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7701 216.01C64.7701 216.01 122.632 177.972 109.093 98.8333C96.0386 41.2939 65.2527 22.4363 61.8687 15.1828C58.1621 10.0254 54.6152 1 54.6152 1L57.0341 161.048C57.0341 161.209 52.0365 210.046 64.7701 216.01Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7701 216.01C64.7701 216.01 122.632 177.972 109.093 98.8333C96.0386 41.2939 65.2527 22.4363 61.8687 15.1828C58.1621 10.0254 54.6152 1 54.6152 1L57.0341 161.048C57.0341 161.209 52.0365 210.046 64.7701 216.01Z",
    fill: "#499D4A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2308 218.105C51.2308 218.105 -3.08606 181.034 0.138055 115.759C3.1993 50.4815 41.5599 18.4078 48.9733 12.605C53.8094 7.44761 53.9708 5.51284 54.2935 0.355469C57.6775 7.60897 57.0336 108.828 57.5161 120.755C58.9668 166.69 54.9374 209.403 51.2308 218.105Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2308 218.105C51.2308 218.105 -3.08606 181.034 0.138055 115.759C3.1993 50.4815 41.5599 18.4078 48.9733 12.605C53.8094 7.44761 53.9708 5.51284 54.2935 0.355469C57.6775 7.60897 57.0336 108.828 57.5161 120.755C58.9668 166.69 54.9374 209.403 51.2308 218.105Z",
    fill: "#58AA50"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongoDb);
export default __webpack_public_path__ + "static/media/mongoDB.4428e2ce754003752672dce4c3d81b9d.svg";
export { ForwardRef as ReactComponent };